import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Grid,
  Row,
  Col
} from "react-bootstrap";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Card } from "components/Card/Card.jsx";
import Pagination from 'components/ThemeComponents/Pagination';
import { adminUserService } from 'services/adminUser';
import { alertActions } from 'redux/actions/alert-actions';
import { hasRole } from 'helper/helperFunctions';

class TwoFactorAuthResetPage extends Component {
  paginationCall = (data) => {
    return adminUserService.getTwoFactorUsers(data.page, data.filter, data.sort, data.pageSize);
  }

  resetTwoFactor = (userId) => {
    adminUserService.resetTwoFactor(userId)
      .then((response) => {
        this.props.alertSuccess(response.message || '2FA has been reset successfully!');
        if (this.pagination) {
          this.pagination.dataCall();
        }
      })
      .catch((error) => {
        this.props.alertError(error);
      });
  }

  resetConfirm = (userId, username) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <div className="react-confirm-alert-body text-center">
              <h3 style={{ color: '#4f7bea', fontSize: '20px' }}>Reset 2FA</h3>
              <p className="marginFromTopPopUp">
                Are you sure you want to reset 2FA for {username}? They will need to set up an authenticator app again.
              </p>
              <div className="react-confirm-alert-button-group alignFlexButtons">
                <button onClick={onClose} className="btn btn-danger">
                  <i className="pe-7s-close-circle"></i> No
                </button>
                <button className="btn btn-success" onClick={() => {
                  this.resetTwoFactor(userId);
                  onClose();
                }}>
                  <i className="pe-7s-check"></i> Yes
                </button>
              </div>
            </div>
          </div>
        );
      }
    });
  }

  render() {
    if (!hasRole(['admin'])) {
      return (
        <div className="content">
          <Grid fluid>
            <Row>
              <Col md={12}>
                <Card content={<p>You do not have permission to view this page.</p>} />
              </Col>
            </Row>
          </Grid>
        </div>
      );
    }

    const columns = [
      {
        Header: "2FA Users",
        headerClassName: 'headerPagination',
        columns: [
          {
            Header: "Username",
            accessor: "username",
            className: "action-center"
          },
          {
            Header: "Email",
            accessor: "email",
            className: "action-center"
          },
          {
            Header: "Role",
            accessor: "role",
            className: "action-center",
            sortable: false
          },
          {
            Header: "Reset 2FA",
            accessor: "id",
            className: "action-center",
            sortable: false,
            Cell: ({ value, original }) => (
              <button
                type="button"
                className="backButton pt-sm no_radius pb-sm primary btn btn-sm btn-info"
                onClick={() => this.resetConfirm(value, original.username)}
              >
                Reset 2FA
              </button>
            )
          }
        ]
      }
    ];

    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                ctTableResponsive
                content={
                  <div>
                    <Grid fluid>
                      <Row>
                        <Col md={12}>
                          <div className="secHeading">2FA Users</div>
                        </Col>
                        <Pagination
                          ref={(p) => this.pagination = p}
                          showPagination={false}
                          columns={columns}
                          pageSize={10}
                          getDataCall={this.paginationCall}
                          filterView={true}
                          filterPlaceHolder="username, email or role"
                          noDataText="No 2FA users found"
                        />
                      </Row>
                    </Grid>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    alertSuccess: (message) => { dispatch(alertActions.success(message)); },
    alertError: (error) => { dispatch(alertActions.error(error)); },
  };
};

const TwoFactorAuthReset = connect(null, mapDispatchToProps)(TwoFactorAuthResetPage);
export default TwoFactorAuthReset;
